export const VossSubscriptionItemTerminationSource = {
    Direct: 0,
    Plan: 1,
    CustomerExpiration: 2,
    Update: 3,
    Unpaid: 4,
    CustomerBlocked: 5,
    CustomerTerminated: 6,
    SubscriptionMerge: 7
}

export const VossSubscriptionItemTerminationSourceText = {
    [VossSubscriptionItemTerminationSource.Direct]: "vossSubscriptionItemTerminationSource.direct",
    [VossSubscriptionItemTerminationSource.Plan]: "vossSubscriptionItemTerminationSource.plan",
    [VossSubscriptionItemTerminationSource.CustomerExpiration]: "vossSubscriptionItemTerminationSource.customerExpiration",
    [VossSubscriptionItemTerminationSource.Update]: "vossSubscriptionItemTerminationSource.update",
    [VossSubscriptionItemTerminationSource.Unpaid]: "vossSubscriptionItemTerminationSource.unpaid",
    [VossSubscriptionItemTerminationSource.CustomerBlocked]: "vossSubscriptionItemTerminationSource.customerBlocked",
    [VossSubscriptionItemTerminationSource.CustomerTerminated]: "vossSubscriptionItemTerminationSource.customerTerminated",
    [VossSubscriptionItemTerminationSource.SubscriptionMerge]: "vossSubscriptionItemTerminationSource.subscriptionMerge"
}